// Настраиваемая цветовая схема
// export const themeColors = {
//   "50": "#f1f9fa",
//   "100": "#dbedf2",
//   "200": "#bbdde6",
//   "300": "#8cc4d4",
//   "400": "#509fb9",
//   "500": "#3a86a1",
//   "600": "#326d88",
//   "700": "#2f5b70",
//   "800": "#2d4c5d",
//   "900": "#294150",
//   "950": "#172935",
// };

export const themeColors = {
  "50": "#f3f6fc",
  "100": "#e6eef8",
  "200": "#c7dbf0",
  "300": "#95bce4",
  "400": "#5c9ad4",
  "500": "#367aba",
  "600": "#2763a2",
  "700": "#214f83",
  "800": "#1f446d",
  "900": "#1f3b5b",
  "950": "#14263d",
};

// Семантические цвета на основе палитры
export const semanticColors = {
  primary: themeColors["500"],
  primaryLight: themeColors["400"],
  primaryDark: themeColors["600"],

  background: {
    default: "#fafbfc",
    paper: "rgba(255, 255, 255, 0.7)",
    glass: "rgba(255, 255, 255, 0.6)",
  },

  text: {
    primary: themeColors["900"],
    secondary: themeColors["700"],
    light: themeColors["600"],
  },

  border: {
    light: "rgba(0, 0, 0, 0.06)",
    medium: "rgba(0, 0, 0, 0.12)",
  },

  glass: {
    background: "rgba(255, 255, 255, 0.72)",
    border: "rgba(255, 255, 255, 0.18)",
  },
};
